import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { RMA_DEFAULT_HTTP_OPTIONS } from '@rma/dashboard/generic/util/environment';
import { appendToRmaApiUrl } from '@rma/generic/ng/util';
import { Observable } from 'rxjs';
import { BillingDetails } from '../entities/billing-details';

@Injectable({
  providedIn: 'root',
})
export class BillingDetailsService {
  private readonly httpClient = inject(HttpClient);
  private readonly rmaApiUrl = inject(appendToRmaApiUrl);

  public updateAgencyDetails(data: BillingDetails, profileCode: string): Observable<void> {
    const url = this.rmaApiUrl(`Agencies/Code-${profileCode}/BillingDetails`);

    return this.httpClient.put<void>(url, data, RMA_DEFAULT_HTTP_OPTIONS);
  }

  public getAgencyDetails(profileCode: string): Observable<BillingDetails> {
    const url = this.rmaApiUrl(`Agencies/Code-${profileCode}/BillingDetails`);
    return this.httpClient.get<BillingDetails>(url, RMA_DEFAULT_HTTP_OPTIONS);
  }
}
